import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';

export const PageNoServiceLocations: FC = () => (
  <CommonError
    title={i18n.page.error.noServiceLocations.title}
    subtitle={[
      i18n.page.error.noServiceLocations.noServiceLocations,
      i18n.page.error.noServiceLocations.waitUntilInstallationIsCompleted,
    ]}
    image={monkeyImageProps}
  />
);
